import angular from 'angular';
import settingsComponent from './settings.component';


let settingsModule = angular.module('settings', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

})



.component('settings', settingsComponent);


export default settingsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/settings/settings.js